<div class="header">
  <div class="left">
    <!-- <a (click)="toggleCollapse()">
    <mat-icon style="color:white; font-size: 2rem; margin-top: 22px; ">dehaze</mat-icon>
  </a> -->
    <div class="logoparent" (click)="OnNavigateToProjectsView()">
      <div class="logo" [style.cursor]="isClassicETActive ? 'pointer' : 'default'">
        <img [src]="safeUrl" />
      </div>
      @if (organization && organization.showOrgNameInHeader) {
      <div class="logotitle" [style.cursor]="isClassicETActive ? 'pointer' : 'default'">
        <h3>{{ organization.name }}</h3>
      </div>
      }
    </div>
  </div>
  <div class="banner">
    <span>{{ currentApplicationName.toLowerCase() }}</span>
  </div>
  <div class="menus">
    <!-- Notification Bell -->
    <div class="notification-bell-wrapper">
      <mat-icon
        [matMenuTriggerFor]="notificationMenu"
        (menuOpened)="onNotificationPanelOpen()"
        class="notification-bell-icon"
        [matBadge]="notificationCount"
        [matBadgeHidden]="notificationCount === 0"
        matBadgeColor="warn"
        matBadgeSize="small"
        matTooltip="Notifications">
        notifications_none
      </mat-icon>
      <mat-menu #notificationMenu="matMenu" class="notification-panel-menu">
        <div class="notif-header" (click)="$event.stopPropagation()">
          <span class="notif-title">Notifications</span>
          @if (notifications?.length > 0) {
            <button class="notif-clear-btn" (click)="clearNotifications()">Clear all</button>
          }
        </div>
        <div class="notif-list" (click)="$event.stopPropagation()">
          @if (notifications?.length === 0) {
            <div class="notif-empty">No notifications yet</div>
          }
          @for (item of notifications; track item.id) {
            <div class="notif-item notif-{{ item.type }}">
              <mat-icon class="notif-type-icon">{{ getNotificationIcon(item.type) }}</mat-icon>
              <div class="notif-content">
                <span class="notif-message">{{ item.message }}</span>
                <span class="notif-time">{{ item.timestamp | date:'MMM d, h:mm a' }}</span>
              </div>
            </div>
          }
        </div>
      </mat-menu>
    </div>

    <!-- Help / YouTube Videos -->
    <div>
      <div>
        <mat-icon [matMenuTriggerFor]="mainHelpMenu" class="help-icon"> help_outline </mat-icon>
      </div>
      <mat-menu #mainHelpMenu="matMenu" class="help-menu-panel" [overlapTrigger]="false" xPosition="after">
        <span mat-menu-item (click)="openVideoPanel()">Latest YouTube Videos </span>
      </mat-menu>
    </div>

    <app-toolbar-app-menu></app-toolbar-app-menu>
    <app-toolbar-user-menu></app-toolbar-user-menu>
  </div>
</div>
@if (gobalAnnouncement && !globalNotificationHidden) {
<div class="announcement">
  <mat-icon style="color: #6dbd4a">notifications</mat-icon>
  <span>{{ gobalAnnouncement }}</span>
  <mat-icon (click)="hideGlobalNotification()" class="close-button">close</mat-icon>
</div>
} @if (organization && organization.announcementText && !notificationHidden) {
<div class="announcement">
  <mat-icon>notifications</mat-icon>
  <span>{{ organization.announcementText }}</span>
  <mat-icon (click)="hideNotification()" class="close-button">close</mat-icon>
</div>
}
